"use strict";
// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * Humla Health API
 * Humla Health API
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.instanceOfPayrollPayPeriodDto = instanceOfPayrollPayPeriodDto;
exports.PayrollPayPeriodDtoFromJSON = PayrollPayPeriodDtoFromJSON;
exports.PayrollPayPeriodDtoFromJSONTyped = PayrollPayPeriodDtoFromJSONTyped;
exports.PayrollPayPeriodDtoToJSON = PayrollPayPeriodDtoToJSON;
exports.PayrollPayPeriodDtoToJSONTyped = PayrollPayPeriodDtoToJSONTyped;
const PayPeriodShiftDto_1 = require("./PayPeriodShiftDto");
/**
 * Check if a given object implements the PayrollPayPeriodDto interface.
 */
function instanceOfPayrollPayPeriodDto(value) {
    if (!('id' in value) || value['id'] === undefined)
        return false;
    if (!('minutesWorked' in value) || value['minutesWorked'] === undefined)
        return false;
    if (!('onCallMinutesWorked' in value) || value['onCallMinutesWorked'] === undefined)
        return false;
    if (!('startDate' in value) || value['startDate'] === undefined)
        return false;
    if (!('endDate' in value) || value['endDate'] === undefined)
        return false;
    if (!('createdAt' in value) || value['createdAt'] === undefined)
        return false;
    if (!('updatedAt' in value) || value['updatedAt'] === undefined)
        return false;
    if (!('shiftId' in value) || value['shiftId'] === undefined)
        return false;
    if (!('shift' in value) || value['shift'] === undefined)
        return false;
    if (!('isFirstPayPeriod' in value) || value['isFirstPayPeriod'] === undefined)
        return false;
    return true;
}
function PayrollPayPeriodDtoFromJSON(json) {
    return PayrollPayPeriodDtoFromJSONTyped(json, false);
}
function PayrollPayPeriodDtoFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'id': json['id'],
        'minutesWorked': json['minutesWorked'],
        'onCallMinutesWorked': json['onCallMinutesWorked'],
        'startDate': (new Date(json['startDate'])),
        'endDate': (new Date(json['endDate'])),
        'createdAt': (new Date(json['createdAt'])),
        'updatedAt': (new Date(json['updatedAt'])),
        'shiftId': json['shiftId'],
        'shift': (0, PayPeriodShiftDto_1.PayPeriodShiftDtoFromJSON)(json['shift']),
        'isFirstPayPeriod': json['isFirstPayPeriod'],
    };
}
function PayrollPayPeriodDtoToJSON(json) {
    return PayrollPayPeriodDtoToJSONTyped(json, false);
}
function PayrollPayPeriodDtoToJSONTyped(value, ignoreDiscriminator = false) {
    if (value == null) {
        return value;
    }
    return {
        'id': value['id'],
        'minutesWorked': value['minutesWorked'],
        'onCallMinutesWorked': value['onCallMinutesWorked'],
        'startDate': ((value['startDate']).toISOString()),
        'endDate': ((value['endDate']).toISOString()),
        'createdAt': ((value['createdAt']).toISOString()),
        'updatedAt': ((value['updatedAt']).toISOString()),
        'shiftId': value['shiftId'],
        'shift': (0, PayPeriodShiftDto_1.PayPeriodShiftDtoToJSON)(value['shift']),
        'isFirstPayPeriod': value['isFirstPayPeriod'],
    };
}
//# sourceMappingURL=PayrollPayPeriodDto.js.map